import { apiService } from 'core/services/apiService';

export interface LogbookSalesMetric {
	id: number;
	name: string;
	description?: string | null;
	displayOrder: number;
	active?: boolean;
	category: string;
}

export interface LogbookSalesMetricPreference {
	id: number;
	workplace: string; // IRI: /api/workplaces/:id
	metric: string; // IRI: /api/logbook_sales_metrics/:id
	active: boolean;
}

const parseIriId = (iri?: string | null): number | null => {
	if (!iri) return null;
	const parts = iri.toString().split('/').filter(Boolean);
	const last = parts[parts.length - 1];
	const n = Number(last);
	return Number.isFinite(n) ? n : null;
};

export const fetchLogbookSalesMetrics = async (): Promise<LogbookSalesMetric[]> => {
	const query = `logbook_sales_metrics?page=1&itemsPerPage=500&pagination=false`;
	const data = apiService.responseHandler(await apiService.get(query));
	return (data?.member as LogbookSalesMetric[]) ?? [];
};

export const fetchLogbookSalesMetricPreferences = async (
	workplaceId: number,
): Promise<LogbookSalesMetricPreference[]> => {
	if (!workplaceId) return [];
	const query = `logbook_sales_metric_preferences?page=1&itemsPerPage=500&pagination=false&workplace=${workplaceId}`;
	const data = apiService.responseHandler(await apiService.get(query));
	return (data?.member as LogbookSalesMetricPreference[]) ?? [];
};

export const upsertLogbookSalesMetricPreference = async ({
	workplaceId,
	metricId,
	active,
}: {
	workplaceId: number;
	metricId: number;
	active: boolean;
}): Promise<any> => {
	const payload = {
		workplace: `/api/workplaces/${workplaceId}`,
		metric: `/api/logbook_sales_metrics/${metricId}`,
		active,
	};

	// Backend is expected to upsert based on (workplace, metric)
	return apiService.responseHandler(await apiService.post('logbook_sales_metric_preferences', payload));
};

export const buildLogbookSalesMetricPreferenceMap = (
	preferences: LogbookSalesMetricPreference[] | undefined,
): Map<number, LogbookSalesMetricPreference> => {
	const map = new Map<number, LogbookSalesMetricPreference>();
	(preferences ?? []).forEach((p) => {
		const metricId = parseIriId(p.metric);
		if (metricId == null) return;
		map.set(metricId, p);
	});
	return map;
};

